import { render, staticRenderFns } from "./RecognitionFilters.vue?vue&type=template&id=390220b2&scoped=true&"
import script from "./RecognitionFilters.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecognitionFilters.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecognitionFilters.vue?vue&type=style&index=0&id=390220b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390220b2",
  null
  
)

export default component.exports